<template>
  <div class="flowmap-box">
    <slot name="sysFlowFiled"></slot>
    <div class="flowmap-header">
      System CPU / MEMORY
    </div>
    <div class="flowmap-content">
      <ul class="flowmap-list">
        <w-flow-map-item-label :perfRecords="systemTabData" perfKey="MEM_PHY/TOTSIZE" label="물리 메모리">
          <w-flow-map-progressbar slot="progressbar" :perfRecords="systemTabData" perfKey="MEM_PHY/USERATE"></w-flow-map-progressbar>
        </w-flow-map-item-label>
        <w-flow-map-item-label :perfRecords="systemTabData" perfKey="MEM_SWP/TOTSIZE" label="SWAP 메모리">
          <w-flow-map-progressbar slot="progressbar" :perfRecords="systemTabData" perfKey="MEM_SWP/USERATE"></w-flow-map-progressbar>
        </w-flow-map-item-label>
        <w-flow-map-item-label :perfRecords="systemTabData" perfKey="CPU/TOTAL_USERATE" :isValue="false" label="CPU 사용률">
          <w-flow-map-progressbar slot="progressbar" :perfRecords="systemTabData" perfKey="CPU/TOTAL_USERATE"></w-flow-map-progressbar>
        </w-flow-map-item-label>
      </ul>
    </div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import WFlowMapProgressbar from './FlowMapProgressbar';
import WFlowMapItemLabel from './FlowMapItemLabel';

export default {
  name: 'WFlowMapSystemTab',
  props: {
    systemTabData: {
      type: Object,
    },
  },
  components: {
    WRscPerfEventProgressBar,
    WFlowMapProgressbar,
    WFlowMapItemLabel,
  },
  computed: {
    eventDataBaseInfo() {
      const dataBaseInfo = this.systemTabData;
      return dataBaseInfo;
    },
  },
  methods: {
    flowMapProgressBarData(data) {
      if (isNil(data)) {
        return 0;
      }
      return data;
    },
    totalDataSize(data) {
      const perfData = this.systemTabData;
      if (isNil(perfData[`${data}/TOTSIZE`])) {
        return '-';
      }
      const size = perfData[`${data}/TOTSIZE`];
      const unit = perfData[`${data}/UNIT`];
      return size + unit;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapSystemTab.vue